/* eslint-disable */
// @ts-nocheck
import React from 'react';
import Button from '../../common/components/core/Button';
import Modal from './Modal';
type Props = {
  closeModal: () => void;
  closeModalWithStop: () => void;
  open: boolean;
};

class ModalPostbackTestingExit extends React.PureComponent<Props> {
  render() {
    return (
      <Modal open={this.props.open} size="md">
        <div className="standard-modal">
          <h4 className="postback-exit-modal__title">Are you sure you want to stop the current postback testing session?</h4>
          <div className="postback-exit-modal__body">
            <div className="h_d-b">
              <div className="h_ta-c h_py-20 h_px-20" data-testid="modal-postback-exit-body">
                You will have to start the test again.
              </div>
            </div>
          </div>
          <div className="standard-modal__footer_center">
            <Button
              className="h_mend-10"
              testid="modal-postback-exit-cancel"
              onClick={this.props.closeModal}
              type="secondary"
            >
              No
            </Button>
            <Button
              testid="modal-postback-exit-confirm"
              className="h_mstart-10"
              onClick={this.props.closeModalWithStop}
              type="danger"
            >
              Yes, Stop
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

export default ModalPostbackTestingExit;
